
import { SFTaxonomyResponse, SFTaxonomy } from "../models/sftaxonomy";
import { SitefinityListItemResponse } from "../models/sflistitem";
import { AnimatedImageHolderComponentProps } from "../components/shops/AnimatedImageHolderComponent";
import { SubHeaderClickHandler } from "../components/shops/SubHeaderMenu";

export const createElementFromHTML = (htmlString: any) => {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.childNodes;
};


export const getListItem = (id: string, isSpanish: boolean): Promise<SitefinityListItemResponse> =>
    fetch(`/api/default/listitems?$filter=ParentId%20eq%20${id}&$orderby=Ordinal&sf_culture=${isSpanish ? 'es' : 'en'}`)
        .then(response => response.json())


export const getListItemsByName = (id: string, isSpanish: boolean): Promise<SitefinityListItemResponse> =>
    fetch(encodeURI(`/api/default/lists?$filter=Title eq '${id}'&sf_culture=${isSpanish ? 'es' : 'en'}`))
        .then(response => response.json())
        .then(j => j.value[0].Id)
        .then(id => getListItem(id, isSpanish))



export const getTaxonomyItems = (id: string, isSpanish: boolean): Promise<SFTaxonomyResponse> => fetch(`/api/default/hierarchy-taxa?$filter=ParentId eq ${id} &$orderby=Ordinal`)
    .then(response => response.json())

export const convertNodeListToAnimatedImageHolderComponentProps = (n: ChildNode, propHolder: AnimatedImageHolderComponentProps, nodeNumber: number, recursionCount: number = 0) => {
    if (nodeNumber === 0) {
        switch (n.nodeName) {
            case 'A':
                propHolder.menuUrl = (n as HTMLAnchorElement).href;
                break;
            case 'IMG':
                propHolder.imageUrl = (n as HTMLImageElement).src
                break;
        }

    } else {
        if (n.hasChildNodes() && recursionCount === 0) {
            let nn = n as HTMLElement;
            console.log(nn.innerHTML + recursionCount)
            Object.assign(propHolder.description, { __html: propHolder.description.__html + nn.innerHTML })
        }
    }


    if (recursionCount == 0) {
        for (let i = 0; i < n.childNodes.length; i++) {
            convertNodeListToAnimatedImageHolderComponentProps(n.childNodes[i], propHolder, nodeNumber, ++recursionCount);
        }
    }

}

export const initAnimatedImageHolderProps = (): AnimatedImageHolderComponentProps => {
    return {
        title: "",
        imageUrl: "",
        description: { __html: "" },
        subHeading: "",
        menuUrl: "",
        category: "",
        tags: [],
        tagsOfInterest: [],
    };
}

export const getShopsList = async (listItem: string, isSpanish: boolean, taxonomyParent: string = ''): Promise<AnimatedImageHolderComponentProps[]> => {

    return getListItem(listItem, isSpanish)
        .then((response: SitefinityListItemResponse) => {
            let comps = [];
            for (let i = 0; i < response.value.length; i++) {
                let holderProps: AnimatedImageHolderComponentProps = initAnimatedImageHolderProps();
                holderProps.title = response.value[i].Title;
                if (taxonomyParent !== '') {
                    holderProps.category = response.value[i].Category.filter((item: string) => item !== '8f6800a1-0c49-6a75-a385-ff1400f4265d').pop() || '';
                }
                const nodeList = createElementFromHTML(response.value[i].Content);
                nodeList.forEach((item, idx) => convertNodeListToAnimatedImageHolderComponentProps(item, holderProps, idx));
                comps.push(holderProps);

            }
            return comps;
        });
};


export const mapShopsTaxonomyResponseToClickHandler = (v: SFTaxonomy, idx: number, handler: () => void): SubHeaderClickHandler => {
    return {
        id: v.Id,
        active: idx === 0,
        text: v.Title,
        altText: v.Title,
        handler
    };
}